module.exports = __webpack_public_path__ + "static/img/078_TO8_1718_og.32ab730.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/078_TO8_1718_og.jpg
// module id = NCC/
// module chunks = 0